export default __webpack_public_path__ + "static/media/rural.1c702c22.svg";